import AppQuotesList from "./AppQuotesList.vue";
import AppQuotesCreate from "./AppQuotesCreate.vue";
import AppQuotesView from "./AppQuotesView.vue";

export default [
    {
        path: "/quotes",
        component: AppQuotesList
    },
    {
        path: "/quotes/new",
        component: AppQuotesCreate
    },
    {
        path: "/quotes/edit/:salesQuote",
        component: AppQuotesCreate, props: true
    },
    {
        path: "/quotes/view/:salesQuote",
        component: AppQuotesView, props: true
    },
]




